// docs: https://github.com/altostra/type-validations#readme
import { maybe, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isTestConnectionResult = objectOf({
  result: string,
  message: maybe(string),
});
